import {
  Box,
  Button,
  Flex,
  IconArrow,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  VStack,
} from '@gazin/ecommerce-ui'
import { theme } from 'src/styles/themes/default'

type StringOrNumber = string | number

type ProductQuantityOptions = {
  label: string
  value: StringOrNumber
}

export type ProductQuantityProps = {
  onChange: (value: StringOrNumber) => void
  onlyShowSuffixWhenListIsOpen?: boolean
  options: ProductQuantityOptions[]
  value: StringOrNumber
  label?: string
  suffix?: string
}

const SELECTED_STYLE = {
  backgroundColor: '#F4F4F7',
  color: theme.primary.main,
  fontWeight: '500',
}

export const ProductQuantity = ({
  onChange,
  onlyShowSuffixWhenListIsOpen,
  options,
  value,
  label,
  suffix,
}: ProductQuantityProps) => {
  const handleChange = (onClose: () => void) => (value: StringOrNumber) => {
    onChange(value)
    onClose()
  }

  return (
    <Popover closeOnBlur={false} flip={false} matchWidth placement="bottom-end">
      {({ isOpen, onClose }) => {
        const needsShowSuffix =
          suffix &&
          (isOpen === onlyShowSuffixWhenListIsOpen ||
            !onlyShowSuffixWhenListIsOpen)

        return (
          <>
            <PopoverTrigger>
              <Button
                aria-label="Adicionar produtos ao carrinho"
                as="div"
                color={theme.colors.grey[200]}
                cursor="pointer"
                display="flex"
                flex="1"
                fontSize=".875rem"
                fontWeight="600"
                height="2.625rem"
                width="full"
              >
                <Flex
                  alignItems={['flex-start', 'center']}
                  direction={['column', 'row']}
                  flex="1"
                  justifyContent="space-between"
                >
                  <Box fontSize=".875rem">{label}</Box>
                  {!!needsShowSuffix && (
                    <Box
                      fontSize=".75rem"
                      lineHeight=".9rem"
                      mr={['.5rem', '.6rem']}
                    >
                      {suffix}
                    </Box>
                  )}
                </Flex>
                <Flex alignItems="center">
                  <IconArrow
                    color={theme.primary.main}
                    height=".65rem"
                    transform={isOpen ? 'rotate(-90deg)' : 'rotate(90deg)'}
                    width=".65rem"
                  />
                </Flex>
              </Button>
            </PopoverTrigger>
            <PopoverContent
              _focus={{ boxShadow: 'none' }}
              borderRadius=".25rem"
              borderWidth="0"
              boxShadow="none"
              data-popper-placement="bottom-end"
              minW={{ base: '100%', lg: 'max-content' }}
              width="inherit"
            >
              <PopoverBody
                borderRadius=".25rem"
                boxShadow="0 .5rem 1.5625rem #1617171A"
                paddingX="0"
              >
                <VStack w="full">
                  {options.map((option) => {
                    const isSelectedItem = option.value === value
                    const applySelectedStyle = isSelectedItem
                      ? SELECTED_STYLE
                      : {}

                    return (
                      <Flex
                        _hover={SELECTED_STYLE}
                        alignContent="flex-start"
                        cursor="pointer"
                        flex="1"
                        fontSize=".875rem"
                        key={option.value}
                        onClick={() => handleChange(onClose)(option.value)}
                        paddingX="1.125rem"
                        paddingY=".625rem"
                        w="full"
                        {...applySelectedStyle}
                      >
                        {option.label}
                      </Flex>
                    )
                  })}
                </VStack>
              </PopoverBody>
            </PopoverContent>
          </>
        )
      }}
    </Popover>
  )
}
